<template>
  <div>
     <p>任务机翻详情传过来的id：{{renwuid}}</p>
      <p>术语新增</p>
    <p class="desc-info">
      <span>订单号：{{ flowInfo.orderId }}</span>
      <span>任务类型：质控</span>
      <span>当前任务状态：{{ this.$flowStatus.get(flowInfo.status) }}</span>
      <span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
      <router-link :to="{path:'/dot/order/detail/'+flowInfo.orderId}" style="margin-right:10px">
        <el-button type="primary" icon="el-icon-document" size="mini" plain>订单详情</el-button>
      </router-link>

      <el-button size="mini" type="warning"
                 v-if=" (flowInfo.status === 1 || flowInfo.status === 2 || flowInfo.status === 3) && permissions.dot_flow_submit "
                 @click.stop="endMission()">结束质控任务
      </el-button>

    </p>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="质控配置" name="1">
        <zkConfigure v-if="configInfo.status !==2" :configInfo="configInfo"
                     ref="zkConfigure"/>
        <zkConfigure2 v-if="configInfo.status === 2" :configInfo="configInfo"
                     ref="zkConfigure2"/>
      </el-tab-pane>
      <el-tab-pane label="质控数据"
                   v-if=" flowInfo.status !== 0 && flowInfo.status !== -1  && flowInfo.status !== 1 && flowInfo.status !== 2 "
                   name="2">
        <zkStatistics :orderId="flowInfo.orderId" ref="zkStatistics"/>
      </el-tab-pane>
      <el-tab-pane label="质控终稿" v-if=" flowInfo.status === 4" name="3">
        <el-row>
          <el-col offset="1">
            <el-radio-group v-model="tranFromat">
              <el-radio label="1">纯译文</el-radio>
              <el-radio label="2">段段对照</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <fileDown
              v-if="(this.flowInfo.orderId&&slan)"
              :fileOption="{title:'终稿-未翻/通过部分为原文'}"
              :type="6"
              :taskType="6"
              :tranFromat="tranFromat"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams" 
              key="qc" ref="qcDown"/>
          </el-col>
          <el-col :span="24">
            <fileDown
              v-if="(this.flowInfo.orderId&&slan)"
              :fileOption="{title:'终稿-未翻部分为译文（未审核的还原为最后一次PE结果，未PE的还原为机翻译文）'}"
              :type="12"
              :tranFromat="tranFromat"
              :taskType="6"
              :orderId="this.flowInfo.orderId" 
              :staParams="staParams"
              key="excel" ref="qcTranDown"/>
          </el-col>

<!--          <el-col :span="24">-->
<!--            <fileDown-->
<!--              :fileOption="{title:'平行语料稿-未翻/通过部分为原文'}"-->
<!--              :type="8"-->
<!--              :orderId="this.flowInfo.orderId" key="qcexcel" ref="qcExcelDown"/>-->
<!--          </el-col>-->

        </el-row>


      </el-tab-pane>
      <el-tab-pane v-if="this.flowInfo.status === 4"  label="平行语料" name="5">
        <el-row>
          <el-col :span="24">
            <fileDown
              v-if="this.flowInfo.orderId"
              :fileOption="{title:'平行语料稿-未翻/通过部分为原文'}"
              :type="8"
              :taskType="6"
              :orderId="this.flowInfo.orderId" 
              :staParams="staParams"
              key="qcexcel" ref="qcExcelDown"/>
          </el-col>
        </el-row>
        <el-col :span="24">
          <fileDown
            v-if="this.flowInfo.orderId"
            :fileOption="{title:'平行语料稿-未翻/通过部分为译文'}"
            :type="18"
            :taskType="6"
            :orderId="this.flowInfo.orderId"
            :staParams="staParams"
            key="peTranDown2" ref="peTranDown2"/>
        </el-col>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import zkConfigure from './qc-configure'
import zkConfigure2 from './qc-configure-status2'
import zkStatistics from './qc-statistics'
import {getFlowInfo, finish,qcConfigInfo,checkfinishQcFlowByPm} from '@/api/dot/qc'
import {getObj} from '@/api/dot/order'
import fileDown from '@/views/common/fileDown'
import {mapGetters} from "vuex";
import {alertErroMsg, alertSuccessMsg} from "@/util/commonMsg";
import {getByStaffId} from "@/api/admin/user";

export default {
  components: {zkConfigure,zkConfigure2, zkStatistics, fileDown},
  data() {
    return {
      tranFromat:'1',
      activeName: "1",
      flowInfo: {},
      configInfo: {},
      page: false,
      slan: "",
      tlan: "",
      qcData: [],
      qcName: "",
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  created: function () {
    this.flowInfo = {}
    this.configInfo = {}
    // console.log(this.$route.params,this.$route.query)
    getFlowInfo(this.$route.params.id).then(response => {
      this.flowInfo = response.data.data

      getObj(this.flowInfo.orderId).then(res => {
        this.slan = res.data.data.slan;
        this.tlan = res.data.data.tlan;
        this.tranFromat = res.data.data.tranFormat + ""
      })


      let tempConfig = this.flowInfo
      if (this.flowInfo.qcConfigDto) {
        tempConfig = this.flowInfo.qcConfigDto
      }
      tempConfig.limitTime = this.flowInfo.limitTime
      tempConfig.wordsCount = this.flowInfo.wordsCount
      tempConfig.qcList = this.flowInfo.userWebVos
      tempConfig.status = this.flowInfo.status
      tempConfig.peEndTime = this.flowInfo.peEndTime
      tempConfig.isConfigDisabled = this.flowInfo.status !== 1
      tempConfig.isQcCanChoose = this.flowInfo.status === 1 || this.flowInfo.status === 2
      tempConfig.orderId = this.flowInfo.orderId;
      this.configInfo = tempConfig
      this.qcName = ""
      if (this.flowInfo.operatorId != null) {
        getByStaffId(this.flowInfo.operatorId).then(response => {
          if (response.data.data && response.data.data.realname) {
            this.qcName = response.data.data.realname
          } else {
            this.qcName = '';
          }
        })
      }


    })

  },
  mounted() {
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === "2") {
        this.$refs.zkStatistics.init();
      } else if (tab.name === "3") {
        this.$refs.qcDown.init();
        this.$refs.qcTranDown.init();
        this.$refs.qcExcelDown.init();
      }else if (tab.name === "5") {
        this.$refs.qcExcelDown.init();
        this.$refs.peTranDown2.init();
      }
    },
    endMission() {
      checkfinishQcFlowByPm({flowId: this.$route.params.id}).then(res=>{
        let code = res.data.data
        if (code === 1) {
          let text = "质控任务还在进行中，此时结束任务，可能造成项目风险，确定结束任务？<br> PS:质控成本仍按照质控领取任务金额结算";
          this.$alert(text, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            dangerouslyUseHTMLString: true,
            callback: action => {
              if (action === 'confirm') {
                //结束QC
                this.finishQc()
              } else {
                this.$router.replace('/refresh')
              }
            },
          });
        } else if (code === 0) {
          //结束QC
          this.finishQc()
        }
      })
      let msg = "";
      //待领取
      if (this.flowInfo.status === 2) {
        msg = "质控任务还未开始，此时结束任务，可能造成风险，确定结束？"
      } else if (this.flowInfo.status === 3) {
        msg = "质控任务还在进行中，此时结束任务，可能造成项目风险，确定结束任务？<br> PS:质控成本仍按照质控领取任务金额结算"
      } else {
        msg = "确定结束任务？"
      }
      // this.$alert(msg, {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   showCancelButton: true,
      //   dangerouslyUseHTMLString: true,
      //   callback: action => {
      //     if (action === 'confirm') {
      //       //结束QC
      //       this.finishQc()
      //     } else {
      //       this.$router.replace('/refresh')
      //     }
      //   },
      // });


    },
    finishQc() {
      finish(this.$route.params.id).then(res => {
        if (res.data.data === 1) {
          alertSuccessMsg()
        } else if (res.data.data === -4) {
          alertErroMsg("PE任务还在进行中，不能结束质控任务")
        } else {
          alertErroMsg()
        }

      })
    },


  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}

</style>
